import { render, staticRenderFns } from "./ModalAddCharge.vue?vue&type=template&id=415445ae&lang=pug&"
import script from "./ModalAddCharge.vue?vue&type=script&lang=js&"
export * from "./ModalAddCharge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports